module.exports = __webpack_public_path__ + "static/facebook logo-008ff835b2b3e2689ff0d22f0a1587e8.png";